@if (content) {
@if (basket.qty) {
<!-- mobile layout -->
<div class="wrap p-b-12 p-t-3"
     cy-basketView
     *ifSize="'SM'">
    <!-- title -->
    <div class="p-t p-r p-b-5 flex flex-bottom">
        <h1 class="h3 col-1">{{'Cart' | translate}}</h1>
        <div class="p1 col-12 m-l-2 inline-block">
            {{ (basket.qty === 1 ? '% item' : '% items') | translate : basket.qty }}
        </div>
    </div>
    <!-- customer info -->
    @if(content.basketCustomerInfo) {
    <div class="bg-col-62 col-1 m-t-4-x m-t-4-l b-a b-col-63"
         style="border-radius: 12px;">
        <p class="p-a center s2"
           *iCms="'basketCustomerInfo' of content; skipEmpty true">
        </p>
    </div>
    }
    <!-- increased spacig -->
    <div class="m-t-5"></div>
    <!-- basket items -->
    @for (item of basket.items | orderBy : ['data.added_at'] : ['desc']; track item; let last = $last) {
    <basket-view-item class="block m-t p-b b-b b-col-4"
                      [class.b-b]="!last"
                      [item]="item"
                      cy-basketproduct></basket-view-item>
    }
    <!-- voucher -->
    <basket-view-coupon-form class="block m-t-12"></basket-view-coupon-form>
    <!-- totals -->
    <basket-view-totals class="block m-t-5 m-t-9-s m-t-9-m"></basket-view-totals>
    <!-- submission -->
    <bottom-panel [bottomPanelRestricted]="['footer']">
        <basket-view-submit class="w-12"></basket-view-submit>
        @if(quoteId && content.copyBasketLink){
        <div class="center m-t-2">
            <button inlineButton
                    (click)="copyBasketLink()"
                    class="va-m s1">{{ (isBasketLinkCopied ? 'Copied' : content.copyBasketLink)
                | translate}}</button>
        </div>
        }
    </bottom-panel>
    @if (!content.hideTrustpilot) {
    <icms-component class="block m-t-12 flex flex-middle flex-justify-center"
                    [data]="getTrustpilotComponentData()"></icms-component>
    }
    <!-- bottom components -->
    <icms-outlet [components]="content.bottomComponents"></icms-outlet>
</div>
<!-- desktop layout -->
<div class="bg-col-w p-t-9 p-b-20"
     cy-basketView
     *ifSize="'XL'">
    <div class="wrap">
        <div class="c-1"></div>
        <div class="c-6 bg-col-52 p-a-9 b-a b-col-5"
             style="border-radius: 12px;">
            <!-- title row -->
            <div class="flex flex-middle flex-justify-between">
                <h1 class="h3 col-1">{{'Cart' | translate}}</h1>
                <div class="p1 col-11">
                    {{ (basket.qty === 1 ? '% item' : '% items') | translate : basket.qty }}
                </div>
            </div>
            <!-- customer info -->
            @if(content.basketCustomerInfo) {
            <div class="bg-col-62 col-1 m-t-4-x m-t-4-l b-a b-col-63"
                 style="border-radius: 12px;">
                <p class="p-a center s2"
                   *iCms="'basketCustomerInfo' of content; skipEmpty true">
                </p>
            </div>
            }
            <!-- basket items -->
            @for (item of basket.items; track item; let last = $last) {
            <basket-view-item class="block m-t p-b b-b b-col-4"
                              [class.b-b]="!last"
                              [item]="item"
                              cy-basketproduct></basket-view-item>
            }
            <!-- bottom components -->
            <icms-outlet [components]="content.bottomComponents"></icms-outlet>
        </div>
        <div class="c-4">
            <div class=" p-t-9 p-b-9 p-l-6 p-r-6 bg-col-52 b-a b-col-5"
                 style="border-radius: 12px;">
                <h2 class="h3">{{'Order summary' | translate}}</h2>
                <!-- totals -->
                <basket-view-totals class="block m-t-6"></basket-view-totals>
                <!-- voucher -->
                <basket-view-coupon-form class="block m-t"></basket-view-coupon-form>
                <!-- submission -->
                <basket-view-submit class="block m-t"></basket-view-submit>
                @if(quoteId && content.copyBasketLink){
                <div class="center m-t-2">
                    <button inlineButton
                            (click)="copyBasketLink()"
                            class="va-m s1">{{ (isBasketLinkCopied ? 'Copied' : content.copyBasketLink)
                        | translate}}</button>
                </div>
                }
                <!-- accepted payments -->
                <basket-view-paywith [payments]="content.payments || []"
                                     class="block m-t-6"></basket-view-paywith>
            </div>
            @if (!content.hideTrustpilot) {
            <icms-component class="block m-t-8 flex flex-middle flex-justify-center"
                            [data]="getTrustpilotComponentData()"></icms-component>
            }
            <!-- side copy -->
            @if (content.sideImage || content.sideCopy) {
            <div class="center m-t-6">
                <div class="w-6">
                    @if(content.sideImage){
                    <div [ngClass]="content.sideImageRatio || 'ratio-1-1'">
                        <img [fill]="true"
                             [dfImage]="content.sideImage"
                             [ratio]="content.sideImageRatio || 1">
                    </div>
                    }
                    <p *iCms="'sideCopy' of content; skipEmpty true"
                       class="m-t"></p>
                </div>
            </div>
            }
        </div>
    </div>
</div>
}
@if (!basket.qty) {
<!-- empty back note -->
<div class="wrap p-b-12 p-t-20 center ">
    <p class="p1"
       *iCms="'emptyCopy' of content"></p>
    <a [routerLink]="'/' | lastCategoryPath"
       class="m-t block"
       [buttonStyle]="'button'"><span *iCms="'emptyCtaCopy' of content"></span></a>
</div>
<!-- empty components -->
<icms-outlet [components]="content.emptyComponents"></icms-outlet>
}
}